import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * fetch all Industry_sector_parent entries
 */
export const fetchIndustry_sector_parentItems = createAsyncThunk(
  "industry_sector_parent/fetchItems",
  async () => {
    const res = await fetch(`${API_BASE}/api/industry_sector_parent`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
    });
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
